module.exports = {
  src: __webpack_public_path__ + "assets/images/ai_helper.ab22ed380380ff6c.png",
  width: 395,
  height: 240,
  toString: function() { return __webpack_public_path__ + "assets/images/ai_helper.ab22ed380380ff6c.png"; }
};